export const SET_CAMPAIGN_BUDGET = 'setCampaignBudget'
export const SET_AD_SET_SPEND_CAP = 'setAdSetSpendCap'
export const SET_OPTIMIZATION_TYPE = 'setOptimizationType'
export const SET_ATTRIBUTION_SPEC = 'setAttributionSpec'
export const SET_BIDDING = 'setBidding'
export const SET_CAMPAIGN_DETAILS_META = 'setCampaignDetailsMeta'
export const SET_ERRORS = 'setErrors'
